import React, { useState } from 'react';
import { Star } from 'lucide-react';

const SIZES = { sm: 14, md: 18, lg: 26, xl: 34 };

const StarRating = ({
  value = 0,
  onChange,
  size = 'md',
  readOnly = false,
  showEmpty = true,
  className = ''
}) => {
  const [hovered, setHovered] = useState(0);
  const px = SIZES[size] || 18;
  const active = hovered || value;

  return (
    <div
      data-testid="star-rating"
      className={`flex items-center gap-0.5 ${className}`}
      role={readOnly ? 'img' : 'radiogroup'}
      aria-label={`Rating: ${value} out of 5`}
    >
      {[1, 2, 3, 4, 5].map(star => {
        const filled = active >= star;
        return (
          <button
            key={star}
            type="button"
            disabled={readOnly}
            onMouseEnter={() => !readOnly && setHovered(star)}
            onMouseLeave={() => !readOnly && setHovered(0)}
            onClick={() => !readOnly && onChange?.(star)}
            data-testid={`star-${star}`}
            className={`transition-transform duration-100 ${
              readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-110 active:scale-95'
            } ${!showEmpty && !filled ? 'opacity-20' : ''}`}
            aria-label={`${star} star`}
          >
            <Star
              size={px}
              className={filled ? 'text-gold' : 'text-gray-200'}
              fill={filled ? '#C9A84C' : 'none'}
              strokeWidth={filled ? 0 : 1.5}
            />
          </button>
        );
      })}
    </div>
  );
};

export const RatingBadge = ({ rating, count, size = 'sm' }) => {
  if (!rating || rating === 0) return null;
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';
  return (
    <div className={`flex items-center gap-1 ${textSize}`}>
      <Star size={size === 'sm' ? 11 : 14} className="text-gold fill-gold" fill="#C9A84C" strokeWidth={0} />
      <span className="font-semibold text-navy">{rating.toFixed(1)}</span>
      {count > 0 && <span className="text-gray-400">({count})</span>}
    </div>
  );
};

export default StarRating;
